import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 30
  },
  box: {
    position: 'relative',
    marginTop: 8,
    height: 460,
    borderRadius: 12,
    background: '#EEF0F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    padding: 16
  },
  // Covers the always-mounted PDF while a generation is in flight.
  overlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 16,
    textAlign: 'center',
    background: '#EEF0F2'
  },
  // Fits the reused react-pdf page into the panel, scaled down to whichever of
  // width or height it hits first, so a whole page is always visible with no
  // scrolling and no clipped corners. No white card — the page sits directly
  // on the grey ground. The `!important`s beat react-pdf's inline sizes.
  doc: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& .react-pdf__Document': {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .react-pdf__Page': {
      width: '100%',
      height: '100%',
      minWidth: '0 !important',
      minHeight: '0 !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // react-pdf paints the wrapper white inline; stretched to the box it
      // would show as white bands around the centered page.
      background: 'transparent !important'
    },
    '& canvas': {
      width: 'auto !important',
      height: 'auto !important',
      maxWidth: '100%',
      maxHeight: '100%',
      display: 'block'
    },
    '& .react-pdf__Page__textContent, & .react-pdf__Page__annotations': {
      display: 'none'
    }
  },
  expandable: {
    cursor: 'zoom-in'
  },
  pager: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    marginTop: 12
  },
  pagerButton: {
    border: '1px solid #E8ECEE',
    width: 32,
    height: 32,
    padding: 0
  },
  spinner: {
    color: '#5D7083'
  },
  // Shown inside the document slot while a PDF (the asset's or a generated
  // one) is downloading; same look as the generating overlay.
  pdfLoading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    textAlign: 'center'
  },
  // Under the asset preview, before anything is generated.
  hint: {
    marginTop: 8,
    textAlign: 'center'
  }
});
